import { render, staticRenderFns } from "./SpeechToTextModal.vue?vue&type=template&id=56e834b0&scoped=true&"
import script from "./SpeechToTextModal.vue?vue&type=script&lang=js&"
export * from "./SpeechToTextModal.vue?vue&type=script&lang=js&"
import style0 from "./SpeechToTextModal.vue?vue&type=style&index=0&id=56e834b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e834b0",
  null
  
)

export default component.exports